import { ClientRegistry } from '../components';
import {
  ClientFilteredComponentSystem,
  FilteredClientComponentSystemUpdateEntityArgs,
} from './ClientBase';

/**
 * Applies skin colour tinting to characters.
 *
 * For entities with the SkinColour component, sets Sprite.tint to match.
 * Currently, this maps 1:1, but in the future it could handle presets or
 * more complex blending with other tint sources (damage flash, etc.).
 */
export class SkinColourSystem extends ClientFilteredComponentSystem {
  public componentClasses: (keyof ClientRegistry)[] = ['SkinColour', 'Sprite'];

  updateEntity({ world, entityId }: FilteredClientComponentSystemUpdateEntityArgs): void {
    const skinColour = world.getComponent(entityId, 'SkinColour')!;
    const sprite = world.getComponent(entityId, 'Sprite')!;

    if (sprite.tint !== skinColour.colour) {
      this.updateComponent(entityId, sprite, { tint: skinColour.colour });
    }
  }
}
